
import React from 'react';
import { PayPalErrorAlert } from './PayPalErrorAlert';
import { CredentialsErrorAlert } from './CredentialsErrorAlert';
import { DetailedErrorInfo } from './DetailedErrorInfo';
import { PayPalError } from '../hooks/subscription/types';

interface ErrorAlertsSectionProps {
  paypalError: PayPalError | null;
  hasCredentialError: boolean;
  showDetailedError: boolean;
  errorDetails: string;
  onShowDetailedError: () => void;
  setErrorDetails: (details: string) => void;
}

export const ErrorAlertsSection = ({ 
  paypalError, 
  hasCredentialError, 
  showDetailedError, 
  errorDetails,
  onShowDetailedError,
  setErrorDetails
}: ErrorAlertsSectionProps) => {
  return (
    <>
      {paypalError && (
        <PayPalErrorAlert 
          errorMessage={paypalError.message} 
          onShowDetailedError={onShowDetailedError} 
          setErrorDetails={() => setErrorDetails(JSON.stringify(paypalError.details, null, 2))}
        />
      )}
      
      {hasCredentialError && (
        <CredentialsErrorAlert 
          missingCredentials={hasCredentialError === true ? ["PAYPAL_CLIENT_ID", "PAYPAL_CLIENT_SECRET", "PAYPAL_PLAN_ID"] : []}
        />
      )}
      
      {showDetailedError && errorDetails && (
        <DetailedErrorInfo errorDetails={errorDetails} />
      )}
    </>
  );
};
